import { PAGE_ONE } from "ui/pagination";
import { IPaginationParams } from "ui/pagination/types";

export const columns = [
  "Date and Time",
  "Type",
  "Description",
  "Amount",
  "Balance",
  "Status",
];

export const ACCOUNT_TRANSACTIONS_PAGE_LIMIT = 10;

export const DEFAULT_ACCOUNT_TRANSACTIONS_PAGINATION_PARAMS: IPaginationParams =
  {
    limit: ACCOUNT_TRANSACTIONS_PAGE_LIMIT,
    page: PAGE_ONE,
  };

export const BUSINESS_SUB_ACCOUNT_NAME_IN_URL_SEPARATOR = "&c&";
